export default __webpack_public_path__ + "static/media/dashboard-icon-active.0bc43668.svg";